import React from 'react'
import PropTypes from 'prop-types'

import ReadMore from 'lib/components/read-more'
import Twicpics from 'lib/tags/twicpics'

import ReviewLine from '~/scenes/course/show/review-line'

import verifiedBadgeIcon from '~/scenes/course/show/_assets/verified-similar-classes-icon.svg'

export default function Course ({ course, width, dpr }) {
  const { reviewCount, averageRating, avatarAlt, avatar, userName } = course

  return (
    <div className='similar-course-container'>
      <a
        className='similar-course-container-link'
        href={course.url}
        target='_blank'
        aria-label={avatarAlt}
        rel='noreferrer'
      >
        <div className='similar-avatar-container'>
          <Twicpics src={avatar} width={width} alt={avatarAlt} dpr={dpr} />
          <div className='verified-badge-container'>
            <img className='verified-badge-icon' alt='verified badge' src={verifiedBadgeIcon} width={19} height={18} />
          </div>
        </div>
        <div className='similar-course-name-container'>
          <div className='similar-course-name'>{userName.split(' ')[0]}</div>
          <div className='similar-course-reviews'>
            {reviewCount > 0 && <ReviewLine averageRating={averageRating} reviewCount={reviewCount} withParentheses />}
          </div>
        </div>
        <div className='similar-course-description'>
          <ReadMore text={course.description} numberOfLines={3} noButton />
        </div>
      </a>
    </div>
  )
}

Course.propTypes = {
  course: PropTypes.object.isRequired,
  width: PropTypes.number.isRequired,
  dpr: PropTypes.number
}
